import React, { Suspense, useState } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import media from 'utils/mediaStyle';
import MainLayout from 'containers/MainLayout';
import styled from 'styled-components';
import LoadingIndicator from 'components/LoadingIndicator';
import CategoryNavMobile from 'containers/CategoryNavMobile';
interface MainLayoutProps extends RouteProps {
  component: any;
  isAuth?: boolean;
}

const Main = styled.div`
  display: flex;
  flex-direction: column;
  ${media.lg`
    flex-direction: row;
  `};
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: calc(100vh - 53px);
`;

export default function ProductListingLayout({ component: Component, isAuth, ...rest }: MainLayoutProps) {
  const [openSearchFilter, setOpenSearchFilter] = useState(false);
  const [canClearFilter, setCanClearFilter] = useState(false);
  const loggedIn = !!localStorage.getItem('token');

  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (!isAuth || loggedIn) {
          return (
            <MainLayout>
              <Main>
                <CategoryNavMobile canClearFilter={canClearFilter} openFilterSearch={() => setOpenSearchFilter(true)} />
                <Suspense fallback={<LoadingIndicator isHomePage={window.location.pathname === '/'} />}>
                  <MainContainer>
                    <Component
                      openSearchFilter={openSearchFilter}
                      setOpenSearchFilter={setOpenSearchFilter}
                      canClearFilter={canClearFilter}
                      setCanClearFilter={setCanClearFilter}
                      {...matchProps}
                    />
                  </MainContainer>
                </Suspense>
              </Main>
            </MainLayout>
          );
        }
        return (
          <Redirect
            to={{
              pathname: '/signin',
              state: { referrer: matchProps.location, redirectPath: '/signin' },
            }}
          />
        );
      }}
    />
  );
}
